import { Directive, ElementRef, HostListener, inject, Input, OnInit, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';

@Directive({
    selector: '[appGoTo]',
    standalone: true,
})
export class GoToDirective implements OnInit {

    @Input('appGoTo') redirectUrl!: string|null;

    router = inject(Router);

    constructor(private el: ElementRef, private renderer: Renderer2) {

    }

    ngOnInit() {
        if (this.redirectUrl) {
            this.renderer.addClass(this.el.nativeElement, 'cursor-pointer');
        }
    }


    @HostListener('click')
    onClick() {
        if (this.redirectUrl) {
            this.router.navigateByUrl(this.redirectUrl);
        }
    }
}
